import LmmEdit from './LmmEdit'
export default LmmEdit


// WEBPACK FOOTER //
// ./src/components/Edit/index.js